
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function CTASection() {
  const [showOrcamentoForm, setShowOrcamentoForm] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  const backgroundImages = [
    'https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/0ef1ea5db573fb304ec3bc1c20697d5f.png',
    'https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/7fbe98da1ec0036d8a130e6b4ee25aaa.png',
    'https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/01c4e12326ffa08cdce5027cdcab8b6c.png',
    'https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/a781a074067766d90f36d535fef72020.png',
    'https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/66a0f3be6917eddf5682e860092d64d6.jpeg'
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === backgroundImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 6000); // Troca a cada 6 segundos

    return () => clearInterval(interval);
  }, [backgroundImages.length]);

  const handleSubmitOrcamento = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d4014m6g28apfrolkp3g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString()
      });
      
      if (response.ok) {
        alert('Solicitação enviada com sucesso! Entraremos em contato em breve.');
        setShowOrcamentoForm(false);
        (e.target as HTMLFormElement).reset();
      }
    } catch (error) {
      alert('Erro ao enviar solicitação. Tente novamente.');
    }
  };

  return (
    <section id="contact" className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative rounded-3xl overflow-hidden">
          {/* Background Images Carousel */}
          <div className="absolute inset-0">
            {backgroundImages.map((image, index) => (
              <div
                key={index}
                className={`absolute inset-0 bg-cover bg-center bg-no-repeat transition-opacity duration-1000 ${
                  index === currentImageIndex ? 'opacity-100' : 'opacity-0'
                }`}
                style={{ backgroundImage: `url('${image}')` }}
              />
            ))}
          </div>
          
          <div className="absolute inset-0 bg-[#5C1A24]/85"></div>
          
          <div className="relative z-10 px-6 py-16 md:px-12 md:py-20 text-center text-white">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>
              Transforme seu projeto em realidade.
            </h2>
            
            <p className="text-lg md:text-xl mb-8 max-w-3xl mx-auto leading-relaxed text-gray-200">
              Fale com a P&amp;P Engenharia e Arquitetura. Nossa equipe está pronta para compreender sua visão e transformá-la em um espaço de alto padrão, dentro das normas e prazos, sem abrir mão da exclusividade.
            </p>
            
            <div className="mt-8 flex flex-col sm:flex-row gap-6 justify-center items-center text-sm text-gray-200">
              <div className="flex items-center">
                <i className="ri-time-line mr-2"></i>
                <span>Resposta em até 24h</span>
              </div>
              <div className="flex items-center">
                <i className="ri-shield-check-line mr-2"></i>
                <span>Consultoria gratuita</span>
              </div>
              <div className="flex items-center">
                <i className="ri-award-line mr-2"></i>
                <span>6+ anos de experiência</span>
              </div>
            </div>
            
            <div className="mt-8">
              <Link
                to="/contato"
                className="bg-transparent border-2 border-white text-white px-6 py-3 rounded-lg font-medium hover:bg-white hover:text-[#5C1A24] transition-all duration-300 cursor-pointer whitespace-nowrap inline-flex items-center gap-2"
              >
                <i className="ri-file-list-3-line"></i>
                Solicite um orçamento personalizado
              </Link>
            </div>
          </div>
          
          {/* Dots Indicator */}
          <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 z-20 flex space-x-2">
            {backgroundImages.map((_, index) => (
              <div
                key={index}
                className={`w-2 h-2 rounded-full transition-all duration-300 ${
                  index === currentImageIndex 
                    ? 'bg-white' 
                    : 'bg-white/40'
                }`}
              />
            ))}
          </div>
        </div>
      </div>

      {/* WhatsApp Floating Button */}
      <div className="fixed bottom-6 right-6 z-50">
        <a
          href="https://wa.me/5511980341891?text=Olá! Gostaria de saber mais sobre os serviços da P&P Engenharia e Arquitetura."
          target="_blank"
          rel="noopener noreferrer"
          className="bg-green-500 hover:bg-green-600 text-white w-14 h-14 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer"
        >
          <i className="ri-whatsapp-line text-xl"></i>
        </a>
      </div>

      {/* Orçamento Form Modal */}
      {showOrcamentoForm && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg p-6 max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-[#5C1A24]">Solicitar Orçamento Personalizado</h3>
              <button 
                onClick={() => setShowOrcamentoForm(false)}
                className="text-gray-500 hover:text-gray-700 cursor-pointer"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <form onSubmit={handleSubmitOrcamento} data-readdy-form id="orcamento-form">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div>
                  <label className="block text-sm font-medium text-[#3F3F3F] mb-1">Nome completo</label>
                  <input 
                    type="text" 
                    name="nome" 
                    required 
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#5C1A24] focus:border-transparent text-sm"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#3F3F3F] mb-1">E-mail</label>
                  <input 
                    type="email" 
                    name="email" 
                    required 
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#5C1A24] focus:border-transparent text-sm"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#3F3F3F] mb-1">Telefone</label>
                  <input 
                    type="tel" 
                    name="telefone" 
                    required 
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#5C1A24] focus:border-transparent text-sm"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#3F3F3F] mb-1">Tipo de projeto</label>
                  <select 
                    name="tipo_projeto" 
                    required 
                    className="w-full px-3 py-2 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#5C1A24] focus:border-transparent text-sm"
                  >
                    <option value="">Selecione uma opção</option>
                    <option value="residencial_casa">Casa Residencial</option>
                    <option value="residencial_apartamento">Apartamento</option>
                    <option value="comercial_escritorio">Escritório</option>
                    <option value="comercial_loja">Loja/Comércio</option>
                    <option value="regularizacao">Regularização</option>
                    <option value="reforma">Reforma</option>
                    <option value="outro">Outro</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#3F3F3F] mb-1">Área aproximada (m²)</label>
                  <input 
                    type="number" 
                    name="area" 
                    min="1"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#5C1A24] focus:border-transparent text-sm"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#3F3F3F] mb-1">Orçamento estimado</label>
                  <select 
                    name="orcamento" 
                    className="w-full px-3 py-2 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#5C1A24] focus:border-transparent text-sm"
                  >
                    <option value="">Selecione uma faixa</option>
                    <option value="ate_100k">Até R$ 100.000</option>
                    <option value="100k_300k">R$ 100.000 - R$ 300.000</option>
                    <option value="300k_500k">R$ 300.000 - R$ 500.000</option>
                    <option value="500k_1m">R$ 500.000 - R$ 1.000.000</option>
                    <option value="acima_1m">Acima de R$ 1.000.000</option>
                  </select>
                </div>
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-[#3F3F3F] mb-1">Localização do projeto</label>
                  <input 
                    type="text" 
                    name="localizacao" 
                    placeholder="Cidade, bairro..."
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#5C1A24] focus:border-transparent text-sm"
                  />
                </div>
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-[#3F3F3F] mb-1">Prazo desejado</label>
                  <select 
                    name="prazo" 
                    className="w-full px-3 py-2 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#5C1A24] focus:border-transparent text-sm"
                  >
                    <option value="">Selecione um prazo</option>
                    <option value="urgente">Urgente (até 1 mês)</option>
                    <option value="curto">Curto prazo (1-3 meses)</option>
                    <option value="medio">Médio prazo (3-6 meses)</option>
                    <option value="longo">Longo prazo (6+ meses)</option>
                  </select>
                </div>
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-[#3F3F3F] mb-1">Descrição do projeto (máx. 500 caracteres)</label>
                  <textarea 
                    name="descricao" 
                    rows={3} 
                    maxLength={500}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#5C1A24] focus:border-transparent text-sm resize-none"
                    placeholder="Descreva sua visão, necessidades específicas, estilo desejado..."
                  ></textarea>
                </div>
              </div>
              <div className="mt-4 flex gap-3">
                <Button type="submit" fullWidth size="sm">
                  Enviar Solicitação
                </Button>
                <Button 
                  type="button" 
                  variant="outline" 
                  onClick={() => setShowOrcamentoForm(false)}
                  className="px-4"
                  size="sm"
                >
                  Cancelar
                </Button>
              </div>
            </form>
          </div>
        </div>
      )}
    </section>
  );
}
